/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { WhseJob0602Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const whseJob0602ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  toStorageBinOptions: INITIAL_STATE.toStorageBinOptions,
  toStorageBinOption: INITIAL_STATE.toStorageBinOption
});

export const whseJob0602FetchWhseJob0602Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const whseJob0602FetchWhseJob0602Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const whseJob0602AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const whseJob0602RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const whseJob0602SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const whseJob0602CreateWhseJob0602Loading = (state, { boolean }) => ({
  ...state,
  createIsLoading: boolean
});

export const whseJob0602CreateWhseJob0602Success = (state, { newDocuments }) => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: [],
  newDocuments
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [WhseJob0602Types.WHSE_JOB0602_RESET_TIMESTAMP]: whseJob0602ResetTimestamp,
  [WhseJob0602Types.WHSE_JOB0602_FETCH_WHSE_JOB0602_LOADING]: whseJob0602FetchWhseJob0602Loading,
  [WhseJob0602Types.WHSE_JOB0602_FETCH_WHSE_JOB0602_SUCCESS]: whseJob0602FetchWhseJob0602Success,
  [WhseJob0602Types.WHSE_JOB0602_ADD_SELECTED_DOCUMENTS]: whseJob0602AddSelectedDocuments,
  [WhseJob0602Types.WHSE_JOB0602_REMOVE_SELECTED_DOCUMENTS]: whseJob0602RemoveSelectedDocuments,
  [WhseJob0602Types.WHSE_JOB0602_SET_WORKSPACE_VISIBLE]: whseJob0602SetWorkspaceVisible,
  [WhseJob0602Types.WHSE_JOB0602_CREATE_WHSE_JOB0602_LOADING]: whseJob0602CreateWhseJob0602Loading,
  [WhseJob0602Types.WHSE_JOB0602_CREATE_WHSE_JOB0602_SUCCESS]: whseJob0602CreateWhseJob0602Success
});
